// @ts-nocheck
const accordion = (): void => {
  const accordions = document.querySelectorAll('[data-accordion]');

  const scrollToAccordion: void = (accordion) => {
    setTimeout(() => {
      const topOffset = 120;
      const accordionPosition =
        accordion.getBoundingClientRect().top +
        document.documentElement.scrollTop -
        topOffset;
      window.scrollTo(0, accordionPosition);
    }, 300);
  };

  const openAccordion: void = (accordion, autoScroll) => {
    const content = accordion.querySelector('[data-accordion-content]');
    accordion.classList.add('accordion__item--open');
    content.style.maxHeight = content.scrollHeight + 'px';
    if (autoScroll) {
      scrollToAccordion(accordion);
    }
  };

  const closeAccordion: void = (accordion) => {
    const content = accordion.querySelector('[data-accordion-content]');
    accordion.classList.remove('accordion__item--open');
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector('[data-accordion-title]');
    const content = accordion.querySelector('[data-accordion-content]');
    if (intro && content) {
      intro.onclick = (): void => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion, true);
        }
      };
    }
  });

  window.addEventListener('hashchange', () => {
    const hash = window.location.hash.replace('#', '');
    const accordion = document.querySelector(
      '[data-accordion-id="' + hash + '"]'
    );

    if (accordion) {
      const intro = accordion.querySelector('[data-accordion-title]');
      const content = accordion.querySelector('[data-accordion-content]');
      if (intro && content) {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion, false);
        }
      }
    }
  });
};

export default accordion;
